import ArticleTitle from './ArticleTitle';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getTitle } from 'state/News/selectors';

export default connect(createStructuredSelector({ title: getTitle }))(
  ArticleTitle,
);
